import createReducer from 'utils/createReducer';
import { combineReducers } from 'redux';
import {
  FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE,
  FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW,
} from './types';

const isShowingUpgradeToMokaposModal = createReducer(false, {
  [FEATURE_RESTRICTION_UPGRADE_MODAL_HIDE]: () => false,
  [FEATURE_RESTRICTION_UPGRADE_MODAL_SHOW]: () => true,
});

export default combineReducers({
  isShowingUpgradeToMokaposModal,
});
